import {
	useInfiniteQuery,
	type InfiniteData,
	type UseInfiniteQueryOptions,
} from '@tanstack/react-query';
import {
	searchAssetObjects,
	searchAssetObjectsEndpoint,
	type QueryError,
	type SearchAssetObjectsResult,
	type SearchAssetObjectsRequestOptions,
} from '../searchAssetObjects';
export * from '../searchAssetObjects';

export type SearchAssetObjectsResultInfiniteData =
	InfiniteData<SearchAssetObjectsResult>;

// page params are handled via the infinite query `pageParams`
export type SearchAssetObjectsQueryParams = Omit<
	SearchAssetObjectsRequestOptions,
	'startIndex' | 'stopIndex'
>;

export type SearchAssetObjectsQueryKey = [
	string,
	SearchAssetObjectsQueryParams,
];

export type SearchAssetObjectsQueryOptions = Omit<
	UseInfiniteQueryOptions<
		SearchAssetObjectsResult,
		QueryError,
		SearchAssetObjectsResult,
		SearchAssetObjectsResult,
		SearchAssetObjectsQueryKey
	>,
	'queryKey' | 'queryFn'
>;

export const SearchAssetObjectsReactQueryKey = searchAssetObjectsEndpoint;

/**
 * react-query wrapper for `searchAssetObjects`
 * @param queryKeyParams
 * @param options
 */
export const useReactQuerySearchAssetObjects = (
	queryKeyParams: SearchAssetObjectsQueryParams,
	options?: SearchAssetObjectsQueryOptions,
) =>
	useInfiniteQuery<
		SearchAssetObjectsResult,
		QueryError,
		SearchAssetObjectsResult,
		SearchAssetObjectsQueryKey
	>({
		queryKey: [searchAssetObjectsEndpoint, queryKeyParams],
		queryFn: ({queryKey, pageParam, signal}) =>
			searchAssetObjects({...queryKey[1], ...pageParam}, signal),
		...options,
	});

export default useReactQuerySearchAssetObjects;
